import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../../shared/services/shared.service';

@Component({
  selector: 'app-un-authorized',
  standalone: true,
  imports: [CommonModule, ButtonComponent, TranslateModule],
  templateUrl: './un-authorized.component.html',
  styleUrl: './un-authorized.component.scss'
})
export class UnAuthorizedComponent {
  /** Optional extra message (e.g., from guard/interceptor) */
  @Input() message = '';
  // This method is used to initialize the class instance using router, translate, and shared service
  constructor(
    private router: Router,
    private translate: TranslateService,
    private sharedService: SharedService
  ) {
    let lang = this.sharedService.getCurrentLang();
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);

    // if(!this.sharedService.getUserProfile()){
    //     this.goToLogin();
    // }
  }
  // This method is used to go to login
  goToLogin() {
    let lang = localStorage.getItem("selectedLang");
    sessionStorage.clear();
    localStorage.clear();
    // Restore language
    if (lang) {
      localStorage.setItem("selectedLang", lang);
    }
    setTimeout(() => {
      this.router.navigate(["/login"]);
    }, 2000);
    //this.router.navigate(['/login'], { queryParams: { redirect: this.router.url } });
  }

  // This method is used to go home
  goHome() {
    this.router.navigate(['/']);
  }
}
